export default "__VITE_ASSET__D6WdmR$w__"